import { memo } from 'react';

import type { ICellRendererParams } from 'ag-grid-community';

import { StatusBadge } from '../../../base';

const StatusRenderer = ({ value }: ICellRendererParams) => <StatusBadge status={value} />;

export default memo(StatusRenderer);
